var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticStyle:{"color":"red"}},[_vm._v(" 温馨提示：包签打印后有效期为30天，超期后将无法用于操作建包，请按需打印。 ")])])
}]

export { render, staticRenderFns }